import { Box, VStack } from '@chakra-ui/react';
import { BuildingOffice2Icon, ListBulletIcon } from '@heroicons/react/24/outline';
import { Heading, Stack, Text } from '@main/complykit';
import { Tag } from '@main/complykit/components/tag';
import { useGetUserByIdQuery } from '@main/graphql/queries/GetUserById.generated';
import { BackofficeUserTabKeys } from '@main/shared/utils';
import { Drawer, getVisibleTabs } from '@main/ui';
import { useMemo } from 'react';

import { OrganizationsTab } from './organizations-tab';

export const UserDrawer = ({ userId }: { userId: string }) => {
  const { tabs } = useUserDrawerTabs(userId);

  const { data, isLoading } = useGetUserByIdQuery({ id: userId });
  const user = data?.user;

  return (
    <Drawer.Layout isLoading={isLoading} isNotFound={!user} canView={true}>
      <Drawer.Toolbar />
      <Drawer.Tabs tabs={tabs}>
        <Box mb={4}>
          <Tag color="purple">Users / {user?.id}</Tag>
        </Box>
        <Heading size="lg">{user?.displayName}</Heading>
      </Drawer.Tabs>
    </Drawer.Layout>
  );
};

const useUserDrawerTabs = (userId: string, parentOrgId?: string) => {
  const tabs = useMemo(
    () =>
      getVisibleTabs<BackofficeUserTabKeys>({
        details: {
          label: 'Details',
          icon: ListBulletIcon,
          panel: <DetailsTab userId={userId} />,
          hideTabTitle: true,
        },
        organizations: {
          label: 'Organizations',
          icon: BuildingOffice2Icon,
          panel: <OrganizationsTab userId={userId} />,
        },
      }),
    [userId],
  );

  return { tabs };
};

function DetailsTab({ userId }: { userId: string }) {
  const { data } = useGetUserByIdQuery({ id: userId });
  const user = data?.user;
  return (
    <VStack spacing={6} alignItems="start">
      <Stack gap={1}>
        <Text size="sm" weight="semibold">
          Id:
        </Text>
        <Text size="sm">{user?.id}</Text>
      </Stack>
      <Stack gap={1}>
        <Text size="sm" weight="semibold">
          Email:
        </Text>
        <Text size="sm">{user?.email}</Text>
      </Stack>
    </VStack>
  );
}
